/**
 * Rude mugs, shown or hidden — the shopper's own switch, which says "Rude": on, shown (snippets/
 * towsons-rude-head.liquid says why and how).
 *
 * The page was marked html.tw-hide-rude (or not) before it was drawn; here every switch on it is
 * set to match — on while rude mugs show — and flipping one: the page marked or unmarked at once, every other switch on it the
 * same, this browser told (with when, so a signed-in customer's account does not flip it back before
 * the save lands), and — for a signed-in customer — the change sent to be kept on their account,
 * through the store's data Worker (window.__twRude: where, who, the day and the proof Shopify's page
 * carries). Where the page's own grid has rude mugs hidden, it says so, with a way to show them.
 *
 * Horizon (10 Oct 2026): its cards are Shopify's own and carry no tags — the rude products' ids (window.__twRude.ids,
 * from the head snippet, which already hides the cards by id) mark each card's holder [data-tw-rude]: the grid's
 * item, a product list's item, a carousel's slide. The switch goes into Horizon's header (<header-actions>) from the
 * head snippet's template, first, before the account and the basket.
 */
(function () {
  if (window.__twRudeWired) return;
  window.__twRudeWired = true;
  // What the shop sells, in its own word (its config, from the portal: lib/storefront/shopWords) — "mug" unless it says otherwise.
  function shopWord(one) { var w = (typeof window !== 'undefined' && window.Towsons && window.Towsons.words) || {}; return one ? (w.item || 'mug') : (w.items || 'mugs'); }
  var html = document.documentElement;
  var me0 = window.__twRude || {};
  var HORIZON = me0.family === 'horizon';

  function hidden() { return html.classList.contains('tw-hide-rude'); }

  function mark() {
    var ids = me0.ids;
    if (!HORIZON || !ids || !ids.length) return;
    var rude = {};
    ids.forEach(function (id) { rude[String(id)] = 1; });
    Array.prototype.forEach.call(document.querySelectorAll('.product-grid__item[data-product-id], product-card[data-product-id]'), function (el) {
      if (!rude[el.getAttribute('data-product-id')]) return;
      var holder = el.closest('.product-grid__item, .resource-list__item, slideshow-slide') || el;
      if (!holder.hasAttribute('data-tw-rude')) holder.setAttribute('data-tw-rude', '');
    });
  }

  function placeSwitch() {
    if (!HORIZON) return;
    var tpl = document.querySelector('template[data-tw-rude-tpl]');
    if (!tpl || !tpl.content) return;
    Array.prototype.forEach.call(document.querySelectorAll('header-actions'), function (actions) {
      if (actions.querySelector('[data-tw-rude-switch]')) return;
      actions.insertBefore(tpl.content.cloneNode(true), actions.firstChild);
    });
  }

  function switches() { return Array.prototype.slice.call(document.querySelectorAll('[data-tw-rude-switch]')); }

  // "3 rude mugs hidden" over the page's own grid (never a menu's or a search box's), and only
  // while they are. Left as it is when nothing has changed — the page is watched for grids drawn
  // again, and a note put back each time would be a change of its own.
  function note() {
    var old = document.querySelector('[data-tw-rude-note]');
    // the shop can do without it (settings.rude.note)
    if ((((window.Towsons || {}).settings || {}).rude || {}).note === false) { if (old) old.parentNode.removeChild(old); return; }
    // Horizon: over its product grid only — never inside a carousel, whose slides Horizon counts and lays out.
    var marked = hidden() ? Array.prototype.slice.call(document.querySelectorAll(HORIZON ? 'main .product-grid__item[data-tw-rude]' : 'main [data-tw-rude]')) : [];
    var grid = marked.length ? marked[0].parentNode : null;
    if (old && grid && old.nextSibling === grid && old.getAttribute('data-n') === String(marked.length)) return;
    if (old) old.parentNode.removeChild(old);
    if (!grid) return;
    var p = document.createElement('p');
    p.className = 'tw-rude-note';
    p.setAttribute('data-tw-rude-note', '');
    p.setAttribute('data-n', String(marked.length));
    p.appendChild(document.createTextNode((marked.length === 1 ? '1 rude ' + shopWord(true) : marked.length + ' rude ' + shopWord(false)) + ' hidden here · '));
    var b = document.createElement('button');
    b.type = 'button';
    b.setAttribute('data-tw-rude-show', '');
    b.textContent = 'Show them';
    p.appendChild(b);
    grid.parentNode.insertBefore(p, grid);
  }

  function sync() {
    placeSwitch();
    mark();
    var on = hidden();
    switches().forEach(function (s) { s.checked = !on; });
    note();
  }

  // Signed in, through the shop's app proxy (me.proxy: the shop's own address, Shopify saying who is signed in — the
  // switch alone is sent, and the browser's own session goes with it); else with the page's proof, to the data service.
  function save(hide) {
    var me = window.__twRude || {};
    var body;
    if (me.proxy && me.u) body = JSON.stringify({ hide: hide });
    else if (me.u && me.c && me.t) body = JSON.stringify({ c: me.c, d: me.d, t: me.t, hide: hide });
    else return;
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(me.u, new Blob([body], { type: 'text/plain' }))) return;
      fetch(me.u, me.proxy ? { method: 'POST', credentials: 'same-origin', keepalive: true, headers: { 'Content-Type': 'text/plain' }, body: body }
        : { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain' }, body: body }).catch(function () {});
    } catch (e) { /* kept in this browser all the same */ }
  }

  function set(hide) {
    html.classList.toggle('tw-hide-rude', hide);
    try {
      localStorage.setItem('tw_hide_rude', hide ? '1' : '0');
      localStorage.setItem('tw_hide_rude_at', String(Date.now()));
    } catch (e) { /* a private window: this page only */ }
    sync();
    save(hide);
  }

  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (t && t.hasAttribute && t.hasAttribute('data-tw-rude-switch')) set(!t.checked);
  });
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (t && t.closest && t.closest('[data-tw-rude-show]')) set(false);
  });
  // Grids drawn again (a filter, the next page, the theme editor): set them as the page is.
  var waiting = false;
  function soon() { if (waiting) return; waiting = true; setTimeout(function () { waiting = false; sync(); }, 50); }
  function start() {
    sync();
    var main = document.querySelector('main');
    if (main && window.MutationObserver) new MutationObserver(soon).observe(main, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', soon);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  // The email preferences page, when a signed-in customer changes their answer about rude designs
  // there: the switch follows at once, as if flipped here (assets/towsons-email-prefs.js).
  window.TowsonsRude = { set: set };
})();
